import { Component } from 'react';
import './App.css';
import DisplayImages from './DisplayImages';

class App extends Component {
  render() {
  return (
    <div className="App">
      <DisplayImages/>
    </div>
  );
  }
}

export default App;
